import { DateTime } from "luxon";

// Helper function to format date based on timezone
const formatDateWithTimezone = (dateString, timezone) => {
  if (!dateString || dateString === "0000-00-00 00:00:00" || dateString === "0000-00-00") {
    return "N/A"; // Return 'N/A' for invalid or empty dates
  }

  // Check if the date string ends with 'Z' (ISO 8601) or uses the SQL format
  let dateInZone;

  if (dateString.includes("T")) {
    // Handle ISO 8601 format, which uses 'T' to separate date and time
    dateInZone = DateTime.fromISO(dateString).setZone(timezone);
  } else if (dateString.includes(" ")) {
    // Handle SQL format (e.g., "2025-07-07 21:15:19")
    dateInZone = DateTime.fromSQL(dateString).setZone(timezone);
  } else {
    return "Invalid Date"; // Return an error message for unknown formats
  }

  // Check if the date parsing was successful
  if (!dateInZone.isValid) {
    return "Invalid Date"; // Return 'Invalid Date' if Luxon couldn't parse
  }

  // Format the date in the desired format with timezone
  return `${dateInZone.toFormat("yyyy-LL-dd HH:mm:ss")} (${dateInZone.offsetNameShort})`;
};

export default formatDateWithTimezone;

export const dateFilterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (!cellValue || cellValue === '0000-00-00 00:00:00') return -1;
    const cellDate = new Date(cellValue);
    if (isNaN(cellDate)) return -1;
    const cellDateNoTime = new Date(cellDate.getFullYear(), cellDate.getMonth(), cellDate.getDate());
    if (cellDateNoTime < filterLocalDateAtMidnight) return -1;
    if (cellDateNoTime > filterLocalDateAtMidnight) return 1;
    return 0;
  }
};
